module.exports = __webpack_public_path__ + "img/emojiTimePlus.d9292f06.svg";